import { createRoute, notFound } from '@tanstack/react-router'

import { appRoute } from '@/app/routes/app-route'
import { lazyPage } from '@/lib/lazy-page'

const DevBroadcastPage = lazyPage(() => import('./features/dev-broadcast/dev-broadcast.lazy'), 'DevBroadcastPage')

export const devBroadcastRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/dev/broadcast',
  // Dev-server only, same idiom as home.tsx: the built SPA must not ship a
  // "notify everyone" form whose backend route 404s in production.
  beforeLoad: () => {
    if (!import.meta.env.DEV) throw notFound()
  },
  component: DevBroadcastPage,
})
